import { render, staticRenderFns } from "./RequestW8BENModal.vue?vue&type=template&id=3b01bcc3&scoped=true&"
import script from "./RequestW8BENModal.vue?vue&type=script&lang=ts&"
export * from "./RequestW8BENModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01bcc3",
  null
  
)

export default component.exports